module.exports = __webpack_public_path__ + "static/media/notfound.60a481c2.gif";